import { ApiClient } from '@k2/common/backend/api-client';
import {VendorIdentity} from '../../../staff/content/clients/client/assignment/common/vendor-identity';
import {Observable} from 'rxjs';
import {FormSpec} from '../../k2-forms-state/types';
import {map} from 'rxjs/operators';
import {AssignmentIdentity} from "@k2/common/entities-state/types";

export class DspEndpoint {
  constructor(
    private readonly api: ApiClient
  ) {

  }

  getOverview = ({ clientId, assignmentId }: AssignmentIdentity) => {
    return this.api.get(
      `/assignment/${assignmentId}/dsp`
    );
  };

  updateBundle = ({ clientId, assignmentId }: AssignmentIdentity, bundledAssignmentServiceInstancesIds: number[]) => {
    const data = {
      assignmentServiceInstanceIds: bundledAssignmentServiceInstancesIds
    };

    return this.api.patch(
      `/assignment/${assignmentId}/dsp`,
      data
    );
  };

  updateNotes = ({ clientId, assignmentId }: AssignmentIdentity, notes: string) => {
    const data = {
      notes: notes
    };

    return this.api
      .patch(
        `/assignment/${assignmentId}/dsp/notes`,
        data
      );
  };

  getVendorFormInitiate = (vendorIdentity: VendorIdentity): Observable<FormSpec> => {
    return this.api
      .get(
        `/assignment/${vendorIdentity.collection.service.assignmentId}/dsp/vendor/${vendorIdentity.vendorId}/form-initiate`
      )
      .pipe(map(response => response.form));
  };

  initiateVendor = (vendorIdentity: VendorIdentity, data: any) => {
    return this.api
      .post(
        `/assignment/${vendorIdentity.collection.service.assignmentId}/dsp/vendor/${vendorIdentity.vendorId}/initiate`,
        data
      );
  };
}
